import QCBadge from "./QCBadge";
export default QCBadge;
